import EfSpec from '@elem/ui/ef-spec';
import EFPicture from '@elem/ui/ef-picture';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');
    const { locale = 'us' } = useRouter();
    const arr = [
        ['https://websiteoss.ecoflow.com/upload/image/1721036967363/pc_ksp_02.jpg', 'https://websiteoss.ecoflow.com/upload/image/1721037170396/m_ksp_02.jpg'],
        ['https://websiteoss.ecoflow.com/upload/image/1721037012625/pc_ksp_06.jpg', 'https://websiteoss.ecoflow.com/upload/image/1721037189573/m_ksp_06.jpg'],
        ['https://websiteoss.ecoflow.com/upload/image/1721037023379/pc_ksp_01.jpg', 'https://websiteoss.ecoflow.com/upload/image/1721037179395/m_ksp_01.jpg'],
        ['https://websiteoss.ecoflow.com/upload/image/1721037047089/pc_ksp_03.jpg', 'https://websiteoss.ecoflow.com/upload/image/1721037209531/m_ksp_03.jpg'],
        ['https://websiteoss.ecoflow.com/upload/image/1721037075896/pc_ksp_05.jpg', 'https://websiteoss.ecoflow.com/upload/image/1721037249201/m_ksp_05.jpg'],
        [
            locale === 'de'
                ? 'https://websiteoss.ecoflow.com/upload/image/1721290401514/pc_de_ksp_04.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1721037114696/pc_ksp_04.jpg',
            locale === 'de'
                ? 'https://websiteoss.ecoflow.com/upload/image/1721290489480/m_de_ksp_04.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1721037220773/m_ksp_04.jpg',
        ],
        [
            locale === 'us'
                ? 'https://websiteoss.ecoflow.com/upload/image/1731567549177/pc.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1721037133862/pc_ksp_07.jpg',
            locale === 'us'
                ? 'https://websiteoss.ecoflow.com/upload/image/1731566939459/h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1721037230123/m_ksp_07.jpg',
        ],
        ['https://websiteoss.ecoflow.com/upload/image/1744602879366/pc_ksp_08.png', 'https://websiteoss.ecoflow.com/upload/image/1744602879203/m_ksp_08.png'],
    ];
    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec spec-x" />
            <div className="inner-content">
                <p className="desc">{t('B_desc')}</p>
                <ul className="cards">
                    {arr.map((item: any, k: number) => (
                        <li className={`card card${k + 1}`} key={k}>
                            <div className="inner">
                                <div className="card-img">
                                    <EFPicture src={item[0]} srcMobile={item[1]} alt={t(`B_text${k + 1}`)} />
                                </div>
                                <p className="card-text">
                                    {t.rich(`B_text${k + 1}`, {
                                        b: (tx: any) => <span className="b">{tx}</span>,
                                        g: (tx: any) => <span className="g">{tx}</span>,
                                        u: (tx: any) => <sup className="u">{tx}</sup>,
                                    })}
                                </p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
            <EfSpec className="spec spec-x" />
        </div>
    );
}
